import { Form, Cascader } from "antd";

export function FormCascade({
  id,
  name = "",
  label,
  options,
  onChange,
  placeholder,
  widthSize = "large",
  rules,
  ...rest
}: any) {
  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "75%";
      case "small":
        return "50%";
      default:
        return "100%";
    }
  })();
  return (
    <div>
      {" "}
      <Form.Item label={label} name={name} rules={rules} layout="vertical">
        <Cascader
          options={options}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: widthPercentage }}
          {...rest}
        />
      </Form.Item>
    </div>
  );
}
